<template>
  <div>
    <h4 class="m-font-size-200 m-font-bold">{{ branch?.name }}</h4>
    <p>{{ branch?.address }}</p>
  </div>
</template>

<script setup>
defineProps({
  branch: {
    type: Object,
    required: true,
  },
});
</script>
